import React, { useState } from 'react';
import './Contact.css';
import Button from './Button';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        message: ''
    });
    const [status, setStatus] = useState({
        submitted: false,
        submitting: false,
        info: { error: false, msg: null }
    });

    const handleOnChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));

        const queryParams = new URLSearchParams(formData).toString();

        try {
            const response = await fetch(`/contact.php?${queryParams}`, {
                method: 'GET',
            });

            if (response.ok) {
                setStatus({
                    submitted: true,
                    submitting: false,
                    info: { error: false, msg: "Message sent successfully!" }
                });
                setFormData({
                    name: '',
                    email: '',
                    company: '',
                    message: ''
                });
            } else {
                setStatus({
                    info: { error: true, msg: "Error: " + response.statusText },
                    submitting: false,
                    submitted: false
                });
            }
        } catch (error) {
            setStatus({
                info: { error: true, msg: "Error connecting to server." },
                submitting: false,
                submitted: false
            });
        }
    };

    return (
        <div className="contact-container">
            <div className="contact-content-wrapper">
                <div className="contact-left-col">
                    <h1 className="contact-title">Let's Talk</h1>
                    <a href="mailto:contact@jeffreyserio.com" className="contact-email-link">
                        contact@jeffreyserio.com
                    </a>
                </div>

                <div className="contact-right-col">
                    {status.submitted ? (
                        <div className="success-container" style={{ textAlign: 'left' }}>
                            <p className="success-message" style={{ color: 'black', fontWeight: '700', fontSize: '1.25rem', lineHeight: '1.5' }}>
                                Thanks for reaching out. <br />
                                I will respond shortly.
                            </p>
                        </div>
                    ) : (
                        <form className="contact-form" onSubmit={handleOnSubmit}>
                            <div className="input-group">
                                <label htmlFor="email" className="input-label">Email*</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="input-box"
                                    required
                                    value={formData.email}
                                    onChange={handleOnChange}
                                />
                            </div>
                            <div className="input-group">
                                <label htmlFor="name" className="input-label">Name*</label>
                                <input
                                    type="text"
                                    id="name"
                                    className="input-box"
                                    required
                                    value={formData.name}
                                    onChange={handleOnChange}
                                />
                            </div>
                            <div className="input-group">
                                <label htmlFor="company" className="input-label">Company*</label>
                                <input
                                    type="text"
                                    id="company"
                                    className="input-box"
                                    required
                                    value={formData.company}
                                    onChange={handleOnChange}
                                />
                            </div>
                            <div className="input-group">
                                <label htmlFor="message" className="input-label">Message*</label>
                                <textarea
                                    id="message"
                                    className="input-box"
                                    required
                                    value={formData.message}
                                    onChange={handleOnChange}
                                />
                            </div>

                            <div className="submit-container">
                                <Button
                                    type="submit"
                                    text={status.submitting ? "Sending..." : "Send"}
                                    onClick={handleOnSubmit}
                                />
                            </div>

                            {status.info.error && (
                                <div className="status-message error" style={{ marginTop: '1em', color: 'red' }}>
                                    {status.info.msg}
                                </div>
                            )}
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Contact;
